import React from 'react';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import moment from 'moment';

const danas = Date.now();

const KalendarSusreta = props => (
  <section id="schedule" data-parallax="/assets/img/event/bg-2.jpg">
    <div className="container">
      <div className="row">
        <div className="col-12 text-center">
          <h2 className="h1">{props.kalendar.title}</h2>
          <div className="u-h-4 u-w-50 bg-primary rounded mt-4 u-mb-70 mx-auto" />
        </div>

        <div className="col-md-6 box-shadow-v2 p-5">
          <ul className="nav nav-pills mb-3 justify-content-center u-ff-dosis u-fs-20 u-fw-600" role="tablist">
            <li className="nav-item">
              <a
                className="nav-link u-rounded-50 active"
                data-toggle="pill"
                href="#susretOpis"
                role="tab"
                aria-selected="true"
                aria-expanded="true"
              >
                Hrvatska
              </a>
            </li>
          </ul>

          <div className="tab-content">
            <div className="tab-pane fade active show rounded" id="susretOpis" role="tabpanel">
              <table className="table table-responsive text-center text-md-left">
                <thead className="bg-primary border-0 text-white">
                  <tr>
                    <th scope="col" className="text-center text-md-left">
                      Klub / Susret
                    </th>
                    <th scope="col" className="text-center text-md-left">
                      Datum
                    </th>
                    <th scope="col" className="text-center text-md-left">
                      Mjesto
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {props.kalendar.hrvatska.map(({ meeting, date, endDate, place, link }) => (
                    <tr key={meeting}>
                      <th scope="row">
                        <a href={link} className="susret-link" target="_blank" rel="noopener noreferrer">
                          {meeting}
                        </a>
                      </th>
                      <td>
                        {moment(date).isBefore(danas, 'day') ? (
                          <Moment format="DD/MM/YY" style={{ textDecoration: 'line-through' }}>
                            {date}
                          </Moment>
                        ) : (
                          <div>
                            <Moment format="DD/MM/YY">{date}</Moment>
                            {moment(date).isBefore(danas, 'day') ? (
                              <div>
                                <span>-</span> <Moment format="DD/MM/YY">{endDate}</Moment>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        )}
                      </td>
                      <td>{place}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="col-md-6 box-shadow-v2 p-5">
          <ul className="nav nav-pills mb-3 justify-content-center u-ff-dosis u-fs-20 u-fw-600" role="tablist">
            <li className="nav-item">
              <a
                className="nav-link u-rounded-50 active"
                data-toggle="pill"
                href="#susretOpis"
                role="tab"
                aria-selected="true"
                aria-expanded="true"
              >
                Susjedne države
              </a>
            </li>
          </ul>

          <div className="tab-content">
            <div className="tab-pane fade active show rounded" id="susretOpis" role="tabpanel">
              <table className="table table-responsive text-center text-md-left">
                <thead className="bg-primary border-0 text-white">
                  <tr>
                    <th scope="col" className="text-center text-md-left">
                      Klub / Susret
                    </th>
                    <th scope="col" className="text-center text-md-left">
                      Datum
                    </th>
                    <th scope="col" className="text-center text-md-left">
                      Mjesto
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {props.kalendar.region.map(({ meeting, date, endDate, place, link }) => (
                    <tr key={meeting}>
                      <th scope="row">
                        <a href={link} className="susret-link" target="_blank" rel="noopener noreferrer">
                          {meeting}
                        </a>
                      </th>
                      <td>
                        {moment(date).isBefore(danas, 'day') ? (
                          <Moment format="DD/MM/YY" style={{ textDecoration: 'line-through' }}>
                            {date}
                          </Moment>
                        ) : (
                          <div>
                            <Moment format="DD/MM/YY">{date}</Moment>
                            {moment(date).isBefore(danas, 'day') ? (
                              <div>
                                <span>-</span>
                                <Moment format="DD/MM/YY">{endDate}</Moment>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        )}
                      </td>
                      <td>{place}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default KalendarSusreta;



// WEBPACK FOOTER //
// ./src/components/KalendarSusreta2018.js